import { isMultiBiz } from '../../../../../../common/utils/accountUtils';
import { useAuth } from '../../../../AuthProvider';
import type { JSX } from 'react';

import './OrderSelectionPath.scss';

export interface OrderProductOfferingsSelectionHeaderProps {
  breadCrumbs: JSX.Element;
}

export const OrderProductOfferingsSelectionHeaderCoCo = ({
  breadCrumbs,
}: OrderProductOfferingsSelectionHeaderProps) => {
  const { authenticatedUser } = useAuth();
  return (
    <>
      {isMultiBiz(authenticatedUser) ? <div className="of-subscription-selection-nav">{breadCrumbs}</div> : breadCrumbs}
    </>
  );
};
